/** Presence is intentional: null/omission is absent; explicit false and zero still author a window. */
export function isCombatStartTimedPassive<T>(def: T, value: (row: T, key: string) => unknown): boolean {
    return value(def, 'triggers_after_combat_begins') != null && value(def, 'duration_type') != null;
}
/** These slots are reprojected by compileCreatureSpeeds when a timed window departs. */
export function isTimedPassiveSpeedLayer<T>(def: T, key: string, value: (row: T, key: string) => unknown): boolean {
    return ['speed_walking', 'speed_swimming', 'speed_climbing', 'speed_burrowing', 'speed_flying', 'speed_hovering', 'teleport'].includes(key)
        && isCombatStartTimedPassive(def, value);
}
